import { Injectable } from "@angular/core";
import { TableService } from "@royalty/service/api";
import { LocalStorageKey } from "@royalty/model";
import { PosHelper } from "@royalty/helpers";
import { ActionType } from "@royalty/keyboard";
import { CoreToolbox } from "../core/utils/core-toolbox";

@Injectable()
export class PosFeatureService {
	constructor(private tableService: TableService) {}

	public lockTable(tableIds: number[], callBack?: Function) {
		const data = {
			id: null,
			ids: tableIds,
		};
		this.storeTableOpening(tableIds);
		this.tableService.lockTable(JSON.stringify(data)).subscribe(() => {
			callBack && callBack(true);
		});
	}

	public unLockTable(tableIds: number[], callBack?: Function) {
		const data = {
			id: null,
			ids: tableIds,
		};
		this.tableService.unLockTable(JSON.stringify(data)).subscribe(() => {
			callBack && callBack(true);
		});
	}

	private storeTableOpening(tableIds: number[]): void {
		let idsStore = tableIds;
		let localIds = JSON.parse(
			CoreToolbox.storageService.getItem(LocalStorageKey.tbls) || null
		);
		if (PosHelper.isArrayWithLength(localIds)) {
			idsStore = tableIds.concat(localIds);
			idsStore = idsStore.filter((x, y) => idsStore.indexOf(x) === y);
		}
		CoreToolbox.storageService.setItem(
			LocalStorageKey.tbls,
			JSON.stringify(idsStore)
		);
	}

	public useNumericOnly(actionType: ActionType): boolean {
		return (
			actionType === ActionType.transfer ||
			actionType === ActionType.guest
		);
	}
}
